export const environment = {
  production: false,

  clientName: 'demo',
  apiGatewayFront: 'https://adminproveedoresostak.takami.co/',
  apiGatewayBackOffice: 'https://adminproveedoresostak.takami.co/',
  apiUrl: 'https://adminproveedoresostak.takami.co/',
  urlPath: 'https://adminproveedoresostak.takami.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LcXCSwqAAAAAKJoMgqjrARoLNTkx4MuAu2cQZxg',

  googleAnalyticsCode: 'UA-140785247-1',
};